var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as BetTypesMap from '../../constants/BetType';
import { openBetSlipModal as openBetSlipModalAction } from '../../actions/coupon/creators/coupon';
import { FormattedMessage, defineMessages } from 'react-intl';
import { getRateDisplayValue } from '../../rendering-commons';
import { selectBetType as selectBetTypeAction } from '../../actions/coupon/creators/coupon';
var messages = defineMessages({
    betslips: {
        id: 'bottom.betslips',
        defaultMessage: 'Купон ставок'
    },
    single: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар',
    },
    express: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс',
    },
    loseToWinAccumulator: {
        id: 'bet_type.loseToWinAccumulator',
        defaultMessage: 'Антиэкспресс',
    },
    system: {
        id: 'bet_type.system_2',
        defaultMessage: 'Система',
    }
});
var Coupons = /** @class */ (function (_super) {
    __extends(Coupons, _super);
    function Coupons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            animated: false
        };
        _this.openBetSlipModal = function () {
            _this.props.openBetSlipModalAction();
        };
        _this.renderBetType = function (betType) {
            switch (betType) {
                case BetTypesMap.SINGLE:
                    return _jsx(FormattedMessage, __assign({}, messages.single));
                case BetTypesMap.EXPRESS:
                    return _jsx(FormattedMessage, __assign({}, messages.express));
                case BetTypesMap.SYSTEM:
                    return _jsx(FormattedMessage, __assign({}, messages.system));
                case BetTypesMap.ANTIEXPRESS:
                    return _jsx(FormattedMessage, __assign({}, messages.loseToWinAccumulator));
            }
        };
        return _this;
    }
    Coupons.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var betTypes = this.props.betTypes;
        if (betTypes !== nextProps.betTypes) {
            var betType = void 0;
            if (nextProps.persistedBetType === undefined) {
                if (nextProps.selectedBetType.rank === undefined && nextProps.selectedBetType.betType === BetTypesMap.SINGLE) {
                    if (nextProps.betTypes.size > 1 && nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; })) {
                        betType = nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; });
                    }
                    else {
                        betType = nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.SINGLE; });
                    }
                    this.props.selectBetTypeAction({ 'betType': betType.type || BetTypesMap.SINGLE });
                }
                else {
                    betType = nextProps.betTypes.find(function (b) { return b.type === nextProps.selectedBetType.betType; });
                    if (!betType) {
                        betType = nextProps.betTypes.get(0);
                    }
                    this.props.selectBetTypeAction({ 'betType': betType.type || BetTypesMap.SINGLE });
                }
            }
            else if (nextProps.selectedBetType.betType === BetTypesMap.SYSTEM && !nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.SYSTEM; })) {
                if (nextProps.betTypes.size > 1 && nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; })) {
                    this.props.selectBetTypeAction({ 'betType': BetTypesMap.EXPRESS });
                }
                else {
                    this.props.selectBetTypeAction({ 'betType': BetTypesMap.SINGLE, rank: null });
                }
            }
            else {
                var persistedBetType_1 = nextProps.persistedBetType;
                if (!nextProps.betTypes.find(function (b) { return b.type === persistedBetType_1; })) {
                    if (nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; })) {
                        this.props.selectBetTypeAction({ 'betType': BetTypesMap.EXPRESS, rank: null });
                    }
                    else {
                        this.props.selectBetTypeAction({ 'betType': BetTypesMap.SINGLE, rank: null });
                    }
                }
                else {
                    if (persistedBetType_1 === BetTypesMap.SYSTEM) {
                        var betType_1 = nextProps.betTypes.find(function (b) { return b.type === BetTypesMap.SYSTEM; });
                        this.props.selectBetTypeAction({ 'betType': BetTypesMap.SYSTEM, rank: betType_1.rank });
                    }
                    else {
                        this.props.selectBetTypeAction({ 'betType': persistedBetType_1, rank: null });
                    }
                }
            }
        }
        //FIXME: Fix this shit;
        if (nextProps.betSlipsSize > this.props.betSlipsSize) {
            this._onTimeout();
            this._timeoutId = window.setTimeout(function () {
                _this.setState({
                    animated: true
                });
            }, 1);
        }
    };
    Coupons.prototype.componentWillMount = function () {
        var betTypes = this.props.betTypes;
        if (betTypes.size > 1 && betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; })) {
            this.props.selectBetTypeAction({ 'betType': BetTypesMap.EXPRESS });
        }
        else {
            this.props.selectBetTypeAction({ 'betType': BetTypesMap.SINGLE });
        }
    };
    Coupons.prototype.componentWillUnmount = function () {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    };
    Coupons.prototype._onTimeout = function () {
        this.setState({
            animated: false
        });
        this._timeoutId = null;
        clearTimeout(this._timeoutId);
    };
    Coupons.prototype.render = function () {
        var _a = this.props, betSlipsSize = _a.betSlipsSize, selectedBetType = _a.selectedBetType, betTypes = _a.betTypes, betSlipModalToggled = _a.betSlipModalToggled;
        var animated = this.state.animated;
        if (betSlipModalToggled) {
            return false;
        }
        var cls = animated ? ' animated' : '';
        var betType;
        var odd = '';
        if (selectedBetType.rank === undefined && selectedBetType.betType === BetTypesMap.SINGLE) {
            if (betTypes.size > 1 && betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; })) {
                betType = betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; });
                odd = getRateDisplayValue(betTypes.find(function (b) { return b.type === BetTypesMap.EXPRESS; }).odd);
            }
            else {
                betType = betTypes.find(function (b) { return b.type === BetTypesMap.SINGLE; });
                if (betType) {
                    odd = getRateDisplayValue(betType.odd);
                }
            }
        }
        else {
            betType = betTypes.find(function (b) { return b.type === selectedBetType.betType; });
            if (betType) {
                odd = getRateDisplayValue(betType.odd);
            }
            else {
                betType = betTypes.get(0);
                if (betType) {
                    odd = getRateDisplayValue(betType.odd);
                }
            }
        }
        return (_jsxs("div", __assign({ className: "coupons".concat(cls), onClick: this.openBetSlipModal }, { children: [_jsxs("div", __assign({ className: 'coupons__left' }, { children: [_jsx("span", __assign({ className: 'coupons__count' }, { children: betSlipsSize })), _jsx(FormattedMessage, __assign({}, messages.betslips))] })), betType !== undefined &&
                    _jsxs("div", __assign({ className: 'coupons__right' }, { children: [_jsx("span", __assign({ className: 'coupons__type' }, { children: this.renderBetType(betType.type) })), _jsx("span", __assign({ className: 'coupons__price' }, { children: odd }))] }))] })));
    };
    return Coupons;
}(Component));
Coupons.propTypes = {
    openBetSlipModalAction: PropTypes.func.isRequired,
    selectBetTypeAction: PropTypes.func.isRequired,
    betSlipsSize: PropTypes.number.isRequired,
    selectedBetType: PropTypes.object.isRequired,
    languageId: PropTypes.number.isRequired,
    betTypes: PropTypes.any,
};
var mapStateToProps = function (state) { return ({
    betSlipsSize: state.coupon.get('betSlips').size,
    selectedBetType: state.coupon.get('selectedBetType'),
    betTypes: state.coupon.get('betTypes'),
    languageId: state.application.get('languageId'),
    betSlipModalToggled: state.application.get('betSlipModalToggled'),
    persistedBetType: state.coupon.get('persistedBetType')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    openBetSlipModalAction: openBetSlipModalAction,
    selectBetTypeAction: selectBetTypeAction
}, dispatch); };
Coupons = connect(mapStateToProps, mapDispatchToProps)(Coupons);
export default Coupons;



// WEBPACK FOOTER //
// ./src/components/coupon/coupons.js